<script>
import range from 'lodash/range';
import pdfJS from 'pdfjs-dist';
import bus from '@/utils/event-bus';
// pdf: instance of PDFData
// see docs for PDF.js for more info
function getPages(pdf, first, last) {
  const allPages = range(first, last + 1).map(number => pdf.getPage(number));
  return Promise.all(allPages);
}

const BUFFER_LENGTH = 10;

function getDefaults() {
  return {
    pages: [],
    cursor: 0,
  };
}

export default {
  name: 'PDFData',
  data() {
    return Object.assign(getDefaults(), {
      pdf: {
        numPages: 0,
      },
    });
  },
  mounted() {
    bus.$on('load-pdf', (file) => {
      // const loadTaks = ;
      // const vm = this;
      // loadTaks.onProgress = function (progress) {
      //   vm.$emit('progress-updated', (progress.loaded / documentSelected.size) * 100);
      // };

    pdfJS.getDocument(file)
      .then((pdf) => {
        this.pdf = pdf;
        this.$emit('document-rendered');
      })
      .catch((response) => {
        this.$emit('document-errored', { text: 'Failed to retrieve PDF', response });
      });

    });
  },
  watch: {
    pdf(pdf, oldPdf) {
      if (!pdf) return;
      if (oldPdf) Object.assign(this, getDefaults());

      this.$emit('page-count', this.pageCount);
      this.fetchPages();
    },
  },

  computed: {
    pageCount() {
      return this.pdf ? this.pdf.numPages : 0;
    },
  },

  methods: {
    getDocumentUrl(documentSelected) {
      if (documentSelected.id !== undefined) {
        if (process.env.NODE_ENV === 'production') {
          return documentSelected.last_document_version.document_path.url;
        }
        return `http://localhost:3000${documentSelected.last_document_version.document_path.url}`;
      }
      return '';
    },
    fetchPages(currentPage = 0) {
      if (!this.pdf) return;
      if (this.pageCount > 0 && this.pages.length === this.pageCount) return;

      const startIndex = this.pages.length;
      if (this.cursor > startIndex) return;

      const startPage = startIndex + 1;
      const endPage = Math.min(Math.max(currentPage, startIndex + BUFFER_LENGTH), this.pageCount);
      this.cursor = endPage;
      getPages(this.pdf, startPage, endPage)
        .then((pages) => {
          const deleteCount = 0;
          this.pages.splice(startIndex, deleteCount, ...pages);
          return this.pages;
        })
        .catch((response) => {
          this.$emit('document-errored', { text: 'Failed to retrieve pages', response });
        });
    },

    onPageRendered({ text, page }) {
    },

    onPageErrored({ text, response, page }) {
      // console.log('Error!', text, response, page);
    },
  },

  created() {
    this.$on('page-rendered', this.onPageRendered);
    this.$on('page-errored', this.onPageErrored);
    this.$on('pages-fetch', this.fetchPages);
  },

  render(h) {
    return h('div', [
      this.$scopedSlots.preview({
        pages: this.pages,
      }),
      this.$scopedSlots.document({
        pages: this.pages,
      }),
    ]);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pdf/PDFData.vue